import accountSuccess from "./account-success.json";
import checkoutSuccess from "./checkout-success.json";
import productThumbInline from "./product-thumb-inline.json";
import productCategoryIds from "./product-category-ids.json";
import productThumb from "./product-thumb.json";
export default {
  accountSuccess,
  checkoutSuccess,
  productThumbInline,
  productCategoryIds,
  productThumb,
};
